import { AccountCenter } from '@/components/sgwt/AccountCenter.tsx';
import { canSeeApplicationsLinks, canSeeRestrictedData } from '@/store/user/userSlice';
import { Link, useMatches } from '@tanstack/react-router';
import { type JSX, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { AccountSearchBar } from '../account/search/AccountSearchBar';
import OtherServicesDropdown from './OtherServicesDropdown';

const routesWithAccountSearchBar = ['/about', '/root/$id'];

export function Header(): JSX.Element {
  const matches = useMatches();
  const canSeeApplicationLinks = useSelector(canSeeApplicationsLinks);
  const isInternalUser = useSelector(canSeeRestrictedData)

  const showAccountSearchBar = useMemo(() => {
    const matchedRouteIds = matches.map(({ routeId }) => routeId) as string[];
    return routesWithAccountSearchBar.some((searchedRouteId) =>
      matchedRouteIds.includes(searchedRouteId),
    );
  }, [matches]);

  return (
    <header className="navbar">
      <div className="navbar-title">
        <a className="navbar-title-link" href="/" aria-label="link to main page">
          <div className="navbar-logo">
            <svg
              aria-hidden="true"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="0" y="0" width="32" height="32" fill="white" />
              <rect x="1" y="1" width="30" height="15" fill="var(--bs-socgen)" />
              <rect x="1" y="16" width="30" height="15" fill="black" />
              <rect x="6" y="15" width="20" height="2" fill="white" />
            </svg>
          </div>
          <div className="navbar-title-divider" />
          <div className="navbar-service-name">
            <FormattedMessage id="sgpbcocktpit" />
          </div>
        </a>
      </div>

      <div className="navbar-content">
        <ul className="navbar-navigation m-0">
          <li className="navbar-item">
            <Link
              to="/"
              search={(prev: any) => ({ ...prev })}
              className="[&.active]:font-bold navbar-link"
              aria-current="page"
              href="#"
            >
              <FormattedMessage id="home" />
            </Link>
          </li>
          {
            // forbidden to external users
            canSeeApplicationLinks && <OtherServicesDropdown />
          }
        </ul>
        {showAccountSearchBar && (
          <div className="px-24px w-100">
            <AccountSearchBar displayEntitySelector={isInternalUser} />
          </div>
        )}
      </div>

      <div className="navbar-toolbar">
        <AccountCenter />
      </div>
    </header>
  );
}
